import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const bankImporterSelectors =
  importerSelectors('bank.importer')

export default bankImporterSelectors
